import type { TApplicantScore, TSaveScorePayload } from '@/services/scoring';
import type { TAssessment, TSaveAssessmentVariables } from '@/services/interviews';

import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';
import { scoringService } from '@/services/scoring';

type TInterviewAssessmentVariables = TSaveAssessmentVariables & TSaveScorePayload;

type TInterviewAssessment = {
  assessment: TAssessment;
  score: TApplicantScore;
};

const saveRubric = async ({ isExisting, ...payload }: TSaveAssessmentVariables): Promise<TAssessment> => {
  if (isExisting) {
    return errorUtils.unwrap(await interviewsService.updateAssessment(payload));
  }

  return errorUtils.unwrap(await interviewsService.saveAssessment(payload));
};

const saveInterviewAssessment = async ({
  applicantID,
  qualityScore,
  archetype,
  staffID,
  ...rubric
}: TInterviewAssessmentVariables): Promise<TInterviewAssessment> => {
  const assessment = await saveRubric(rubric);

  const score = errorUtils.unwrap(await scoringService.saveScore({
    applicantID,
    qualityScore,
    archetype,
    staffID,
  }));

  return { assessment, score };
};

export type {
  TInterviewAssessment,
  TInterviewAssessmentVariables,
};
export {
  saveInterviewAssessment,
};
